export class Show {
  constructor(public text: string, public type: string = 'danger') {

  }
}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/model/show.model.ts